import React, { useEffect, useState } from 'react'
import dashbordStore from '../../../../store/dashbord'
import ButtonGrey from '../../../ui/buttonGrey/buttonGrey'
import { PositionRowItem } from './positionRowItem'
import usePosition from '../../../../hooks/position.hook'
import useDashbord from '../../../../hooks/dashbord.hook'
import Loader from '../../../loader/loader'
import { useNotification } from '../../../../hooks/notification.hook'
import Modal from '../../../modal/modal'
import userStore from '../../../../store/users'

const getCurrentCPositionStage = stages => {
  if (!Array.isArray(stages) || !stages.length) {
    return null
  }
  return [...stages].reverse().find(x => x.isCurrentStage) ?? null
}

export const PositionsTable = (
  {
    data,
    showOrderKitModal,
    orderIdDB,
    onSelectPosition,
    onPositionDetail,
    getData
  }
) => {
  const notification = useNotification()
  const { isHeadOfProduction } = userStore
  const { updateDrawingsUnion, deleteDrawingsUnion } = usePosition()
  const { getRemoteStocks } = useDashbord()
  const [remoteStocksMap, setRemoteStocksMap] = useState({})
  const [editMode, setEditMode] = useState({
    isActive: false,
    currentUnionHash: null,
    currentDrawingCode: null,
    existsUnionEdit: false
  })
  const [isLoading, setIsLoading] = useState(false)
  const [selectedDrawings, setSelectedDrawings] = useState({})
  const [hoveredUnionHash, setHoveredUnionHash] = useState(null)
  const [deleteWarning, setDeleteWarning] = useState(
    { isOpen: false, hash: null })
  const selectedDrawingsCount = Object.keys(selectedDrawings).length
  const allDrawingsOfOrder = data?.positions.map(pos => (pos.drawings.map(dr => dr.id)))
  const allDrawingsOfOrderLength = allDrawingsOfOrder.flat().length
  const isShowUnionEditControl = data?.positions.length > 1 && allDrawingsOfOrderLength > 1 && isHeadOfProduction && !editMode.isActive

  const onSetEditMode = ({
    isInitOpen,
    selectedUnionHash,
    selectedDrawingCode
  }) => () => {
    let unionHash = crypto.randomUUID()
    if (!isInitOpen) {
      unionHash = selectedUnionHash
    }
    const editModeConfig = {
      isActive: true,
      existsUnionEdit: !isInitOpen,
      currentUnionHash: unionHash,
      currentDrawingCode: isInitOpen ? null : selectedDrawingCode
    }

    if (!isInitOpen && selectedUnionHash) {
      const allOrderDrawings = data.positions.reduce((acc, curr) => {
        acc = [...acc, ...curr.drawings]
        return acc
      }, [])
      const selectedUnion = allOrderDrawings.filter(
        (dr) => dr.union_hash === selectedUnionHash)
      if (selectedUnion.length) {
        const formatSelectedUnion = selectedUnion.reduce((acc, curr) => {
          acc[curr.id] = {
            id: curr.id,
            code: curr.code
          }
          return acc
        }, {})
        setSelectedDrawings(formatSelectedUnion)
      }
    }
    setEditMode(editModeConfig)
    setHoveredUnionHash(null)
  }


  const onCancelEditMode = () => {
    const editModeConfig = {
      isActive: false,
      currentUnionHash: null,
      currentDrawingCode: null,
      existsUnionEdit: false
    }
    setSelectedDrawings({})
    setEditMode(editModeConfig)
  }

  const onSelectDrawing = (data) => {
    const updatedSelectedDrawings = { ...selectedDrawings }

    if (updatedSelectedDrawings[data.id]) {
      delete updatedSelectedDrawings[data.id]
    } else {
      updatedSelectedDrawings[data.id] = data
    }

    const updatedEditConfig = {
      ...editMode,
      currentDrawingCode: data.code
    }

    if (!Object.keys(updatedSelectedDrawings).length) {
      updatedEditConfig.currentDrawingCode = null
    }

    setSelectedDrawings(updatedSelectedDrawings)
    setEditMode(updatedEditConfig)
  }

  const onSaveDrawingsUnion = async () => {
    try {
      const payload = {
        drawings: Object.values(selectedDrawings),
        union_hash: editMode.currentUnionHash
      }
      setIsLoading(true)
      await updateDrawingsUnion(payload)
      await getData()
      onCancelEditMode()
      notification('Методы печати объединены')
    } catch (error) {
      console.error(error)
      notification('Что-то пошло не так', 'error')
    } finally {
      setIsLoading(false)

    }
  }

  useEffect(() => {
    const loadRemoteStocks = async () => {
      const { data: list = [] } = (await getRemoteStocks()) || {}
      const map = list.reduce((acc, item) => {
        acc[item.stockId] = item.stockName
        return acc
      }, {})
      setRemoteStocksMap(map)
    }
    loadRemoteStocks()
  }, [getRemoteStocks])

  const onUnionDelete = (hash) => {
    setDeleteWarning({ isOpen: true, hash })
  }
  const onUnionDeleteApprove = async () => {
    try {
      const { hash } = deleteWarning
      if (hash) {
        setIsLoading(true)
        await deleteDrawingsUnion({
          union_hash: hash
        })
        await getData()
        notification('Методы печати разгруппированы')
      }
    } catch (e) {
      console.error('onUnionDeleteApprove', e)
      notification('Что-то пошло не так', 'error')
    } finally {
      setIsLoading(false)
      setDeleteWarning({ isOpen: false, hash: null })
    }
  }

  return (
    <div className="pb-[2rem]">
      {isLoading && (
        <div className={`absolute inset-0 z-[10] bg-[#000000] opacity-[0.4]`}>
          <Loader />
        </div>
      )}
      {
        data.positions.map((position) => {
            const { kitID, c_position_stages, id } = position
            const isSelected = dashbordStore.getIsPositionsSelected(id)
            const c_position_ID = c_position_stages[0]?.id
            const currentCps = getCurrentCPositionStage(c_position_stages)
            const remoteStockName =
              position.remoteStockId != null ? remoteStocksMap[position.remoteStockId] : undefined
            const onOpenSetModal = e => {
              e.stopPropagation()
              showOrderKitModal(orderIdDB, kitID)
            }

            return (
              <PositionRowItem
                remoteStockName={remoteStockName}
                isCurrentStageForRemoteLabel={!!currentCps}
                stageStepForRemoteLabel={currentCps?.stage?.step}
                getData={getData}
                isHeadOfProduction={isHeadOfProduction}
                setHoveredUnionHash={setHoveredUnionHash}
                hoveredUnionHash={hoveredUnionHash}
                onSetEditMode={onSetEditMode}
                selectedDrawings={selectedDrawings}
                onSelectDrawing={onSelectDrawing}
                key={id}
                editMode={editMode}
                position={position}
                isSelected={isSelected}
                c_position_ID={c_position_ID}
                onSelectPosition={onSelectPosition}
                onOpenSetModal={onOpenSetModal}
                onPositionDetail={onPositionDetail}
                onUnionDelete={onUnionDelete}
              />
            )
          }
        )
      }
      <div>
        {isShowUnionEditControl &&
          <ButtonGrey classes={`mt-[2rem]`}
                      onPress={onSetEditMode({ isInitOpen: true })}
                      name="Объединение настройки печати"></ButtonGrey>}
        {editMode.isActive && <div className="flex gap-[1rem]">
          <ButtonGrey classes={`mt-[2rem]`} onPress={onCancelEditMode}
                      name="Омена"></ButtonGrey>
          <ButtonGrey success disabled={selectedDrawingsCount < 2}
                      classes={`mt-[2rem]`} onPress={onSaveDrawingsUnion}
                      name="Сохранить"></ButtonGrey>
        </div>
        }
      </div>

      <Modal closeModal={() => setDeleteWarning({ isOpen: false, hash: null })}
             isOpen={deleteWarning.isOpen}>
        <div className="w-[62rem] min-h-[10rem]">
          <div className="py-[5rem] px-[7rem]">
            <div className="flex flex-col gap-[2rem]">
              <span className="text-Regular(24_30) text-center">Внимание!</span>
              <span className="text-Regular(18_24) text-center">
                Вы собираетесь расформировать выбранную группу методов печати
              </span>
              <div className="flex justify-center gap-[5rem]">
                <div onClick={onUnionDeleteApprove}
                     className="hover:bg-Accent/Light_Green hover:cursor-pointer duration-300 ease-in-out min-w-[19rem] py-[1.1rem] group px-[1.8rem]  font-medium rounded-[8px] bg-Accent/Green text-white text-Regular(16_20)">
                  <span
                    className="flex justify-center  items-center gap-[0.8rem]">
                    <span>Да, расформировать</span>
                    <i className="icon-fcheck-circle text-Regular(18_24)"></i>
                  </span>
                </div>
                <div
                  onClick={() => setDeleteWarning(
                    { isOpen: false, hash: null })}
                  className="hover:bg-Accent/Red_Middle hover:cursor-pointer duration-300 ease-in-out min-w-[19rem] py-[1.1rem] group px-[1.8rem]  font-medium rounded-[8px] bg-Accent/Red text-white text-Regular(16_20)">
                  <span
                    className="flex justify-center  items-center gap-[0.8rem]">
                    <span>Отмена</span>
                    <i className="icon-times-circle text-Regular(18_24)"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

    </div>
  )
}